<script setup lang="ts">
import { useRouter } from 'vue-router'
import type { GroupedByType } from '../../../../../../Types/notification'
import NotificationEmptyState from './NotificationEmptyState.vue'
import NotificationGroupItem from './NotificationGroupItem.vue'

interface Props {
  groups: GroupedByType[]
  isTeamView?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  isTeamView: false,
})

const router = useRouter()

const handleGroupClick = (alertTypeId: number): void => {
  const routeData = router.resolve({
    path: '/notifications',
    query: {
      alertType: String(alertTypeId),
      ...(props.isTeamView && { team: 'true' }),
    },
  })

  window.open(routeData.href, '_blank')
}
</script>

<template>
  <div class="notification-scroll-container overflow-auto">
    <NotificationEmptyState v-if="groups.length === 0" />
    <NotificationGroupItem v-for="group in groups" :key="group.alertTypeId" :group="group" @click="handleGroupClick" />
  </div>
</template>

<style lang="scss" scoped>
.notification-scroll-container {
  max-height: 300px;
}
</style>
